export default function paginationHeaders(response) {
  const total = parseInt(response.headers['x-total'])
  const perPage = parseInt(response.headers['x-per-page'])
  const page = parseInt(response.headers['x-page'])
  return {
    total,
    perPage,
    page,
  }
}
